import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  modal: {
    width: 720
  },
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    lineHeight: 1.4,
    marginBottom: theme.spacing(6)
  },
  optionCards: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  optionCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    backgroundColor: theme.colorPalette.beige_50,
    borderRadius: 4,
    padding: theme.spacing(6),
    gap: theme.spacing(4),
    // Reskin: an inset panel inside the modal.
    ...reskinStyles(theme, theme.cardStyles.inset)
  },
  optionCardMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(4)
  },
  optionText: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    flex: '1 1 0',
    minWidth: 0
  },
  optionTitle: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    color: theme.colorPalette.green_80
  },
  optionDescription: {
    color: theme.colorPalette.green_100
  },
  actionButton: {
    height: 36,
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 16,
    padding: theme.spacing(2, 4),
    borderRadius: 4,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    gap: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.colorPalette.green_90
    },
    // Reskin: a secondary action pill, so dark green isn't a competing action color.
    ...reskinStyles(theme, { ...theme.actionStyles.secondary, borderRadius: 22, padding: theme.spacing(0, 5.5) })
  },
  cardFooter: {
    borderTop: `1px solid ${theme.colorPalette.beige_60}`,
    paddingTop: theme.spacing(4)
  },
  cardFooterContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  blockedNotice: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    backgroundColor: theme.colorPalette.beige_50,
    borderRadius: 4,
    padding: theme.spacing(4, 6)
  },
  blockedNoticeText: {
    color: theme.colorPalette.green_100
  },
  blockedButton: {
    opacity: 0.5,
    '&:hover': {
      backgroundColor: theme.colorPalette.green_100
    }
  },
  alertIcon: {
    flexShrink: 0
  },
  cardFooterText: {
    fontSize: 12,
    lineHeight: 1.5,
    color: theme.colorPalette.green_100
  },
  generatingPdfText: {
    fontWeight: 400,
    fontSize: 12,
    color: theme.colorPalette.orange_50
  },
  footerLink: {
    fontWeight: 400,
    fontSize: 12,
    color: theme.colorPalette.orange_50,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    },
    ...reskinStyles(theme, {
      textDecoration: 'underline',
      textDecorationThickness: '1px',
      '&:hover': { textDecoration: 'underline', textDecorationThickness: '2px' }
    })
  },
  downloadButton: {
    width: 205
  },
  // The spinner stands in for the icon and label while the locked link's cluster is prepared.
  hiddenIcon: {
    display: 'none'
  },
  buttonIcon: {
    paddingRight: theme.spacing(1)
  }
});

export default makeStyles(styles);
